import { render } from "./building_inner_page.vue?vue&type=template&id=f8f58e2e"
import script from "./building_inner_page.vue?vue&type=script&lang=js"
export * from "./building_inner_page.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__